tinymce.addI18n("fr_FR", {
    "#": "#",
    "Accessibility": "Accessibilit\xe9",
    "Accordion": "Accord\xe9on",
    "Accordion body...": "Corps de l'accord\xe9on...",
    "Accordion summary...": "R\xe9sum\xe9 de l'accord\xe9on...",
    "Action": "Action",
    "Activity": "Activit\xe9",
    "Address": "Adresse",
    "Advanced": "Options avanc\xe9es",
    "Align": "Aligner",
    "Align center": "Centrer",
    "Align left": "Aligner \xe0 gauche",
    "Align right": "Aligner \xe0 droite",
    "Alignment": "Alignement",
    "Alignment {0}": "Alignement {0}",
    "All": "Tout",
    "Alternative description": "Description alternative",
    "Alternative source": "Source alternative",
    "Alternative source URL": "URL de la source alternative",
    "Anchor": "Ancre",
    "Anchor...": "Ancre...",
    "Anchors": "Ancres",
    "Animals and Nature": "Animaux & nature",
    "Arrows": "Fl\xe8ches",
    "B": "B",
    "Background color": "Couleur d'arri\xe8re-plan",
    "Background color {0}": "Couleur d'arri\xe8re-plan {0}",
    "Black": "Noir",
    "Block": "Bloc",
    "Block {0}": "Bloc {0}",
    "Blockquote": "Bloc de citation",
    "Blocks": "Blocs",
    "Blue": "Bleu",
    "Blue component": "Composant bleu",
    "Body": "Corps",
    "Bold": "Gras",
    "Border": "Bordure",
    "Border color": "Couleur de bordure",
    "Border style": "Style de la bordure",
    "Border width": "\xc9paisseur de la bordure",
    "Bottom": "En bas",
    "Browse files": "Consulter les fichiers",
    "Browse for an image": "Rechercher une image",
    "Browse links": "Consulter les liens",
    "Bullet list": "Liste \xe0 puces",
    "Cancel": "Annuler",
    "Caption": "L\xe9gende",
    "Cell": "Cellule",
    "Cell padding": "Marge int\xe9rieure des cellules",
    "Cell properties": "Propri\xe9t\xe9s de la cellule",
    "Cell spacing": "Espacement entre les cellules",
    "Cell styles": "Type de cellule",
    "Cell type": "Type de cellule",
    "Center": "Centre",
    "Characters": "Caract\xe8res",
    "Characters (no spaces)": "Caract\xe8res (espaces non compris)",
    "Circle": "Cercle",
    "Class": "Classe",
    "Clear formatting": "Effacer la mise en forme",
    "Close": "Fermer",
    "Code": "Code",
    "Code sample...": "Exemple de code...",
    "Code view": "Affichage du code",
    "Color Picker": "S\xe9lecteur de couleurs",
    "Color swatch": "\xc9chantillon de couleurs",
    "Cols": "Colonnes",
    "Column": "Colonne",
    "Column clipboard actions": "Actions du presse-papiers des colonnes",
    "Column group": "Groupe de colonnes",
    "Column header": "En-t\xeate de colonne",
    "Constrain proportions": "Limiter les proportions",
    "Copy": "Copier",
    "Copy column": "Copier la colonne",
    "Copy row": "Copier la ligne",
    "Could not find the specified string.": "Impossible de trouver la cha\xeene sp\xe9cifi\xe9e.",
    "Could not load emojis": "Impossible de charger les emojis",
    "Count": "Total",
    "Currency": "Devise",
    "Current window": "Fen\xeatre active",
    "Custom color": "Couleur personnalis\xe9e",
    "Custom...": "Personnalis\xe9e...",
    "Cut": "Couper",
    "Cut column": "Couper la colonne",
    "Cut row": "Couper la ligne",
    "Dark Blue": "Bleu fonc\xe9",
    "Dark Gray": "Gris fonc\xe9",
    "Dark Green": "Vert fonc\xe9",
    "Dark Orange": "Orange fonc\xe9",
    "Dark Purple": "Violet fonc\xe9",
    "Dark Red": "Rouge fonc\xe9",
    "Dark Turquoise": "Turquoise fonc\xe9",
    "Dark Yellow": "Jaune fonc\xe9",
    "Dashed": "Tirets",
    "Date/time": "Date/heure",
    "Decrease indent": "R\xe9duire le retrait",
    "Default": "Par d\xe9faut",
    "Delete accordion": "Supprimer l'accord\xe9on",
    "Delete column": "Supprimer la colonne",
    "Delete row": "Supprimer la ligne",
    "Delete table": "Supprimer le tableau",
    "Dimensions": "Dimensions",
    "Disc": "Disque",
    "Div": "Div",
    "Document": "Document",
    "Dotted": "Pointill\xe9",
    "Double": "Deux traits continus",
    "Drop an image here": "D\xe9poser une image ici",
    "Dropped file type is not supported": "Le type de fichier d\xe9pos\xe9 n'est pas pris en charge",
    "Edit": "Modifier",
    "Embed": "Incorporer",
    "Emojis": "\xc9mojis",
    "Emojis...": "\xc9mojis...",
    "Error": "Erreur",
    "Error: Form submit field collision.": "Erreur\xa0: conflit de champs lors de la soumission du formulaire.",
    "Error: No form element found.": "Erreur : aucun \xe9l\xe9ment de formulaire trouv\xe9.",
    "Extended Latin": "Latin \xe9tendu",
    "Failed to initialize plugin: {0}": "\xc9chec d'initialisation de l'extension\xa0: {0}",
    "Failed to load plugin url: {0}": "\xc9chec de chargement de l'URL du plug-in\xa0: {0}",
    "Failed to load plugin: {0} from url {1}": "\xc9chec de chargement du plug-in\xa0: {0} \xe0 partir de l\u2019URL {1}",
    "Failed to upload image: {0}": "\xc9chec d'envoi de l'image\xa0: {0}",
    "File": "Fichier",
    "Find": "Rechercher",
    "Find (if searchreplace plugin activated)": "Rechercher (si l'extension 'searchreplace' est activ\xe9e)",
    "Find and Replace": "Trouver et remplacer",
    "Find and replace...": "Trouver et remplacer...",
    "Find in selection": "Trouver dans la s\xe9lection",
    "Find whole words only": "Mot entier",
    "Flags": "Drapeaux",
    "Focus to contextual toolbar": "Mettre le focus sur la barre d'outils contextuelle",
    "Focus to element path": "Mettre le focus sur le chemin vers l'\xe9l\xe9ment",
    "Focus to menubar": "Mettre le focus sur la barre de menu",
    "Focus to toolbar": "Mettre le focus sur la barre d'outils",
    "Font": "Police",
    "Font size {0}": "Taille de police\xa0{0}",
    "Font sizes": "Tailles de police",
    "Font {0}": "Police {0}",
    "Fonts": "Polices",
    "Food and Drink": "Nourriture & boissons",
    "Footer": "Pied de page",
    "Format": "Format",
    "Format {0}": "Format\xa0{0}",
    "Formats": "Formats",
    "Fullscreen": "Plein \xe9cran",
    "G": "V",
    "General": "G\xe9n\xe9ral",
    "Gray": "Gris",
    "Green": "Vert",
    "Green component": "Composant vert",
    "Groove": "Sculpt\xe9",
    "Handy Shortcuts": "Raccourcis utiles",
    "Header": "En-t\xeate",
    "Header cell": "Cellule d'en-t\xeate",
    "Heading 1": "Titre\xa01",
    "Heading 2": "Titre\xa02",
    "Heading 3": "Titre\xa03",
    "Heading 4": "Titre\xa04",
    "Heading 5": "Titre\xa05",
    "Heading 6": "Titre\xa06",
    "Headings": "Titres",
    "Height": "Hauteur",
    "Help": "Aide",
    "Hex color code": "Code couleur hexad\xe9cimal",
    "Hidden": "Masqu\xe9",
    "Horizontal align": "Alignement horizontal",
    "Horizontal line": "Ligne horizontale",
    "Horizontal space": "Espace horizontal",
    "ID": "ID",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "L'ID doit commencer par une lettre, suivie uniquement par des lettres, num\xe9ros, tirets, points, deux-points et underscores.",
    "Image is decorative": "L'image est d\xe9corative",
    "Image list": "Liste des images",
    "Image title": "Titre d'image",
    "Image...": "Image...",
    "ImageProxy HTTP error: Could not find Image Proxy": "Erreur HTTP d'ImageProxy : Impossible de trouver ImageProxy",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "Erreur HTTP d'ImageProxy : URL de ImageProxy incorrecte",
    "ImageProxy HTTP error: Rejected request": "Erreur HTTP d'ImageProxy : Requ\xeate rejet\xe9e",
    "ImageProxy HTTP error: Unknown ImageProxy error": "Erreur HTTP d'ImageProxy : Erreur ImageProxy inconnue",
    "Increase indent": "Augmenter le retrait",
    "Inline": "En ligne",
    "Insert": "Ins\xe9rer",
    "Insert Template": "Ins\xe9rer le mod\xe8le",
    "Insert accordion": "Ins\xe9rer un accord\xe9on",
    "Insert column after": "Ins\xe9rer une colonne apr\xe8s",
    "Insert column before": "Ins\xe9rer une colonne avant",
    "Insert date/time": "Ins\xe9rer date/heure",
    "Insert image": "Ins\xe9rer une image",
    "Insert link (if link plugin activated)": "Ins\xe9rer un lien (si l'extension 'link' est activ\xe9e)",
    "Insert row after": "Ins\xe9rer une ligne apr\xe8s",
    "Insert row before": "Ins\xe9rer une ligne avant",
    "Insert table": "Ins\xe9rer un tableau",
    "Insert template...": "Ins\xe9rer un mod\xe8le...",
    "Insert video": "Ins\xe9rer une vid\xe9o",
    "Insert/Edit code sample": "Ins\xe9rer / modifier un bloc de code",
    "Insert/edit image": "Ins\xe9rer/modifier image",
    "Insert/edit link": "Ins\xe9rer/modifier lien",
    "Insert/edit media": "Ins\xe9rer/modifier un m\xe9dia",
    "Insert/edit video": "Ins\xe9rer/modifier une vid\xe9o",
    "Inset": "Incrust\xe9",
    "Invalid hex color code: {0}": "Code couleur hexad\xe9cimal invalide : {0}",
    "Invalid input": "Entr\xe9e invalide",
    "Italic": "Italique",
    "Justify": "Justifier",
    "Keyboard Navigation": "Navigation au clavier",
    "Language": "Langue",
    "Learn more...": "En savoir plus...",
    "Left": "Gauche",
    "Left to right": "De gauche \xe0 droite",
    "Light Blue": "Bleu clair",
    "Light Gray": "Gris clair",
    "Light Green": "Vert clair",
    "Light Purple": "Violet clair",
    "Light Red": "Rouge clair",
    "Light Yellow": "Jaune clair",
    "Line height": "Hauteur de la ligne",
    "Link list": "Liste des liens",
    "Link...": "Lien...",
    "List Properties": "Propri\xe9t\xe9s de la liste",
    "List properties...": "Lister les propri\xe9t\xe9s...",
    "Loading emojis...": "Chargement des emojis...",
    "Loading...": "Chargement...",
    "Lower Alpha": "Alphabet en minuscules",
    "Lower Greek": "Alphabet grec en minuscules",
    "Lower Roman": "Chiffre romain inf\xe9rieur",
    "Match case": "Respecter la casse",
    "Mathematical": "Op\xe9rateurs math\xe9matiques",
    "Media poster (Image URL)": "Affiche de m\xe9dia (URL de l'image)",
    "Media...": "M\xe9dia...",
    "Medium Blue": "Bleu moyen",
    "Medium Gray": "Gris moyen",
    "Medium Purple": "Violet moyen",
    "Merge cells": "Fusionner les cellules",
    "Middle": "Au milieu",
    "Midnight Blue": "Bleu de minuit",
    "More...": "Plus...",
    "Name": "Nom",
    "Navy Blue": "Bleu marine",
    "New document": "Nouveau document",
    "New window": "Nouvelle fen\xeatre",
    "Next": "Suivante",
    "No": "Non",
    "No alignment": "Aucun alignement",
    "No color": "Aucune couleur",
    "Nonbreaking space": "Espace ins\xe9cable",
    "None": "Aucun",
    "Numbered list": "Liste num\xe9rot\xe9e",
    "OR": "OU",
    "Objects": "Objets",
    "Ok": "Ok",
    "Open help dialog": "Ouvrir la bo\xeete de dialogue d'aide",
    "Open link": "Ouvrir le lien",
    "Open link in...": "Ouvrir le lien dans...",
    "Open popup menu for split buttons": "Ouvrir le menu contextuel pour les boutons partag\xe9s",
    "Orange": "Orange",
    "Outset": "Relief",
    "Page break": "Saut de page",
    "Paragraph": "Paragraphe",
    "Paste": "Coller",
    "Paste as text": "Coller comme texte",
    "Paste column after": "Coller la colonne apr\xe8s",
    "Paste column before": "Coller la colonne avant",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Le collage est maintenant en mode texte brut. Les contenus seront coll\xe9s sans retenir les formatages jusqu'\xe0 ce que vous d\xe9sactiviez cette option.",
    "Paste or type a link": "Coller ou taper un lien",
    "Paste row after": "Coller la ligne apr\xe8s",
    "Paste row before": "Coller la ligne avant",
    "Paste your embed code below:": "Collez votre code incorpor\xe9 ci-dessous :",
    "People": "Personnes",
    "Plugins": "Plug-ins",
    "Plugins installed ({0}):": "Extensions install\xe9es ({0})\xa0:",
    "Powered by {0}": "Avec {0}",
    "Pre": "Pr\xe9format\xe9",
    "Preferences": "Pr\xe9f\xe9rences",
    "Preformatted": "Pr\xe9format\xe9",
    "Premium plugins:": "Plug-ins premium\xa0:",
    "Press the Up and Down arrow keys to resize the editor.": "Appuyez sur les touches fl\xe9ch\xe9es haut et bas pour redimensionner l'\xe9diteur.",
    "Press the arrow keys to resize the editor.": "Appuyez sur les touches fl\xe9ch\xe9es pour redimensionner l'\xe9diteur.",
    "Press {0} for help": "Appuyez sur {0} pour obtenir de l'aide",
    "Preview": "Aper\xe7u",
    "Previous": "Pr\xe9c\xe9dente",
    "Print": "Imprimer",
    "Print...": "Imprimer...",
    "Purple": "Violet",
    "Quotations": "Citations",
    "R": "R",
    "Range 0 to 255": "Plage de 0 \xe0 255",
    "Red": "Rouge",
    "Red component": "Composant rouge",
    "Redo": "Refaire",
    "Remove": "Retir\xe9",
    "Remove color": "Supprimer la couleur",
    "Remove link": "Enlever le lien",
    "Replace": "Remplacer",
    "Replace all": "Remplacer tout",
    "Replace with": "Remplacer par",
    "Resize": "Redimensionner",
    "Restore last draft": "Restaurer le dernier brouillon",
    "Reveal or hide additional toolbar items": "Affichez ou masquez les \xe9l\xe9ments suppl\xe9mentaires de la barre d'outils",
    "Rich Text Area": "Zone de Texte Riche",
    "Rich Text Area. Press ALT-0 for help.": "Zone de Texte Riche. Appuyez sur ALT-0 pour l'aide.",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Zone de Texte Riche. Appuyez sur ALT-F9 pour le menu. Appuyez sur ALT-F10 pour la barre d'outils. Appuyez sur ALT-0 pour l'aide",
    "Ridge": "Extrud\xe9",
    "Right": "Droite",
    "Right to left": "De droite \xe0 gauche",
    "Row": "Ligne",
    "Row clipboard actions": "Actions du presse-papiers des lignes",
    "Row group": "Groupe de lignes",
    "Row header": "En-t\xeate de ligne",
    "Row properties": "Propri\xe9t\xe9s de la ligne",
    "Row type": "Type de ligne",
    "Rows": "Lignes",
    "Save": "Enregistrer",
    "Save (if save plugin activated)": "Enregistrer (si l'extension 'save' est activ\xe9e)",
    "Scope": "\xc9tendue",
    "Search": "Rechercher",
    "Select all": "S\xe9lectionner tout",
    "Select...": "S\xe9lectionner...",
    "Selection": "S\xe9lection",
    "Shortcut": "Raccourci",
    "Show blocks": "Afficher les blocs",
    "Show caption": "Afficher une l\xe9gende",
    "Show invisible characters": "Afficher les caract\xe8res invisibles",
    "Size": "Taille",
    "Solid": "Trait continu",
    "Source": "Source",
    "Source code": "Code source",
    "Special Character": "Caract\xe8re sp\xe9cial",
    "Special character...": "Caract\xe8re sp\xe9cial...",
    "Split cell": "Diviser la cellule",
    "Square": "Carr\xe9",
    "Start list at number": "Liste de d\xe9part au num\xe9ro",
    "Strikethrough": "Barr\xe9",
    "Style": "Style",
    "Subscript": "Indice",
    "Superscript": "Exposant",
    "Switch to or from fullscreen mode": "Passer en ou quitter le mode plein \xe9cran",
    "Symbols": "Symboles",
    "System Font": "Police syst\xe8me",
    "Table": "Tableau",
    "Table caption": "L\xe9gende de tableau",
    "Table properties": "Propri\xe9t\xe9s du tableau",
    "Table styles": "Style tableau",
    "Template": "Mod\xe8le",
    "Templates": "Mod\xe8les",
    "Text": "Texte",
    "Text color": "Couleur du texte",
    "Text color {0}": "Couleur du texte {0}",
    "Text to display": "Texte \xe0 afficher",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "L'URL que vous avez saisie semble \xeatre une adresse e-mail. Souhaitez-vous y ajouter le pr\xe9fixe requis mailto:\xa0?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "L'URL que vous avez saisie semble \xeatre un lien externe. Souhaitez-vous y ajouter le pr\xe9fixe requis mailto:\xa0?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "L'URL que vous avez saisie semble \xeatre un lien externe. Voulez-vous ajouter le pr\xe9fixe https:// requis\xa0?",
    "Title": "Titre",
    "To open the popup, press Shift+Enter": "Pour ouvrir la popup, appuyez sur Maj+Entr\xe9e",
    "Toggle accordion": "Activer l'accord\xe9on",
    "Tools": "Outils",
    "Top": "En haut",
    "Travel and Places": "Voyages et lieux",
    "Turquoise": "Turquoise",
    "Underline": "Soulign\xe9",
    "Undo": "Annuler",
    "Upload": "T\xe9l\xe9charger",
    "Uploading image": "T\xe9l\xe9versement d'une image",
    "Upper Alpha": "Alphabet en majuscules",
    "Upper Roman": "Chiffre romain sup\xe9rieur",
    "Url": "URL",
    "User Defined": "D\xe9fini par l'utilisateur",
    "Valid": "Valide",
    "Version": "Version",
    "Vertical align": "Alignement vertical",
    "Vertical space": "Espace vertical",
    "View": "Afficher",
    "Visual aids": "Aides visuelles",
    "Warn": "Avertir",
    "White": "Blanc",
    "Width": "Largeur",
    "Word count": "Nombre de mots",
    "Words": "Mots",
    "Words: {0}": "Mots\xa0: {0}",
    "Yellow": "Jaune",
    "Yes": "Oui",
    "You are using {0}": "Vous utilisez {0}",
    "You have unsaved changes are you sure you want to navigate away?": "Vous avez des modifications non enregistr\xe9es, \xeates-vous s\xfbr de vouloir quitter la page\xa0?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "Votre navigateur ne supporte pas l\u2019acc\xe8s direct au presse-papiers. Merci d'utiliser les raccourcis clavier Ctrl+X/C/V.",
    "alignment": "alignement",
    "austral sign": "Symbole austral",
    "cedi sign": "Symbole cedi",
    "colon sign": "symbole col\xf3n",
    "cruzeiro sign": "Symbole cruzeiro",
    "currency sign": "symbole devise",
    "dollar sign": "symbole dollar",
    "dong sign": "Symbole dong",
    "drachma sign": "Symbole drachme",
    "euro-currency sign": "symbole euro",
    "example": "exemple",
    "formatting": "mise en forme",
    "french franc sign": "symbole franc fran\xe7ais",
    "german penny symbol": "Symbole pfennig",
    "guarani sign": "Symbole guarani",
    "history": "historique",
    "hryvnia sign": "Symbole hryvnia",
    "indentation": "retrait",
    "indian rupee sign": "Symbole roupie indienne",
    "kip sign": "Symbole kip",
    "lira sign": "Symbole lire",
    "livre tournois sign": "Symbole livre tournois",
    "manat sign": "Symbole manat",
    "mill sign": "Symbole milli\xe8me",
    "naira sign": "Symbole naira",
    "new sheqel sign": "Symbole nouveau ch\xe9kel",
    "nordic mark sign": "Symbole du mark nordique",
    "peseta sign": "Symbole peseta",
    "peso sign": "Symbole peso",
    "ruble sign": "Symbole rouble",
    "rupee sign": "Symbole roupie",
    "spesmilo sign": "Symbole spesmilo",
    "styles": "styles",
    "tenge sign": "Symbole tenge",
    "tugrik sign": "Symbole tougrik",
    "turkish lira sign": "Symbole lire turque",
    "won sign": "Symbole won",
    "yen character": "Sinogramme Yen",
    "yen/yuan character variant one": "Sinogramme Yen/Yuan, premi\xe8re variante",
    "yuan character": "Sinogramme Yuan",
    "yuan character, in hong kong and taiwan": "Sinogramme Yuan, Hong Kong et Taiwan",
    "{0} characters": "{0}\xa0caract\xe8res",
    "{0} columns, {1} rows": "\xa0{0}\xa0colonnes,\xa0{1}\xa0lignes",
    "{0} words": "{0} mots"
});